import type { FC } from 'react'

import tasLogo from '@/assets/tas.svg'

export const Home: FC = () => (
  <main className='flex flex-col items-center justify-center gap-4 p-8 xl:pt-16'>
    <img src={tasLogo} alt='TAS Logo' className='size-40' />
    <h1 className='font-kanji text-center text-5xl break-keep'>
      富木 合氣道
      <br />
      スペイン
    </h1>
    <h1 className='font-display text-center text-4xl font-bold'>
      Tomiki Aikido
      <br />
      Spain
    </h1>
    <p className='mt-16 text-xl'>Website under construction...</p>
  </main>
)

export default Home
